const AnjuAlbumsStatic = () => {
    return (
      <>

        <div class="gallery_containerThree-static">  

                <div class="gallery_item">
                  <p class="gallery-tag">Album</p>
                    <a href="https://open.spotify.com/album/0oK5HB9kStuPQgkT3kzeHT?si=Bo8MHRMRREeEt4aph7TCaw" target="_blank" rel="noopener noreferrer">
                        <img src="https://i1.sndcdn.com/artworks-yteAvdxDvR6I55bi-43Pjlw-t500x500.jpg" width="100%" alt=""/><br/>
                        <p class="gallery-text">
                            <strong>Solid State Memories</strong><br/>
                        </p>
                    </a>
                </div>  

                <div class="gallery_item">
                  <p class="gallery-tag">Album</p>
                    <a href="https://open.spotify.com/album/0aHHZXbflT5Cznb2CEJw9T" target="_blank" rel="noopener noreferrer">
                        <img src="https://i1.sndcdn.com/artworks-wwoT34wzHbb7vSWv-fe9Xfg-t500x500.jpg" width="100%" alt=""/><br/>
                        <p class="gallery-text">
                            <strong>ANJU is Now Online!</strong><br/>
                        </p>
                    </a>
                </div>     

            </div>

      </>
    );
  };
  export default AnjuAlbumsStatic;